<template>
  <aside class="sidebar">
    <div class="content">
      <!-- BACK -->
      <a class="back" @click="$router.push('/dashboard')">
        <svg width="8" height="12" viewBox="0 0 8 12">
          <path d="M6 12L0 6L6 0L7.4 1.4L2.8 6L7.4 10.6L6 12Z" fill="#182773"/>
        </svg>
        Kembali ke Dashboard
      </a>
      <h3>Lengkapi Form Anggota</h3>
      <p class="desc">Selangkah lagi untuk menjadi anggota resmi</p>

      <!-- STEPS -->
      <ul class="steps">
        <li
          v-for="(step, index) in steps"
          :key="step.id"
          :class="stepClass(index)"
        >
          <!-- ICON -->
          <span class="step-icon">
            <!-- completed -->
            <svg
              v-if="index < activeStep"
              width="20" height="20" viewBox="0 0 20 20"
            >
              <circle cx="10" cy="10" r="10" fill="#4C66A4"/>
              <path d="M5 10l3 3 6-6" stroke="#fff" stroke-width="2" fill="none"/>
            </svg>
            <!-- active / inactive-->
            <template v-else>
              <span
                class="step-icon"
                v-html="index === activeStep ? step.iconActive : step.iconInactive"
              />
            </template>
          </span>
          <!-- LABEL -->
          <span class="step-label">
            {{ step.label }}
          </span>
          <!-- ARROW (active only) -->
          <span v-if="index === activeStep" class="arrow">
            <svg width="6" height="10" viewBox="0 0 6 10">
              <path d="M1 9L5 5L1 1" stroke="#667085" stroke-width="2" fill="none"/>
            </svg>
          </span>
        </li>
      </ul>
      <BenefitAccordion
        v-if="activeStep === 0"
        :show="activeStep === 0"
      />
    </div>
  </aside>
</template>

<script>
import BenefitAccordion from './BenefitAccordion.vue'

export default {
  name: 'RegisterSidebar',
  components: {
    BenefitAccordion
  },
  props: {
    steps: {
      type: Array,
      required: true
    },
    activeStep: {
      type: Number,
      default: 0
    }
  },
  methods: {
    stepClass (index) {
      return {
        active: index === this.activeStep,
        completed: index < this.activeStep
      }
    }
  }
}
</script>

<style scoped>
.sidebar {
  max-width: 450px;
  padding: 24px;
  background: #F5F6FA;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  height: 100%;
}

/* CONTENT */
.content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
  height: 100%;
}

.back {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #14264D;
  cursor: pointer;
  margin-bottom: 16px;
}

.desc {
  color: #667085;
  font-size: 14px;
}

/* STEPS */
.steps {
  list-style: none;
  padding: 0;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.steps li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  color: #344054;
  font-weight: 600;
}

/* ACTIVE */
.steps li.active {
  background: #fff;
}

/* ICON */
.step-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
}

/* LABEL */
.step-label {
  flex: 1;
}

/* ARROW */
.arrow {
  display: flex;
  align-items: center;
  margin-right: 4px;
}

/* VISION+ BENEFITS SECTION */
.benefits-section {
  margin-top: 24px;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  border: solid 1px #D6DFF4;
  margin-bottom: -18px;
}

.benefits-header {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
}

.vision-logo {
  flex-shrink: 0;
}

.benefits-title h4 {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  margin: 0;
  line-height: 1.4;
}

.benefits-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.benefit-item {
  display: flex;
  gap: 12px;
}

.benefit-icon {
  flex-shrink: 0;
}

.benefit-content h5 {
  font-size: 14px;
  font-weight: 600;
  color: #1F2937;
  margin: 0 0 4px 0;
}

/* LOGO */
.logo {
  margin-top: 24px;
  padding-top: 24px;
  flex-shrink: 0;
}
</style>
